import { LOGO_COLORS, RING, leafSvgPath } from "@/components/3d/hero/logo-shape";

/** Logo Alert AI em SVG: aparece até a versão 3D carregar (ou quando não há WebGL). */
export default function LogoMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="-1.1 -1.1 2.2 2.2"
      className={className}
      style={{ filter: "drop-shadow(0 0 28px rgb(43 155 255 / 0.5))" }}
      aria-hidden="true"
      focusable="false"
    >
      <path d={leafSvgPath()} fill={LOGO_COLORS.leaf} />
      <circle cx={RING.cx} cy={-RING.cy} r={RING.outer} fill={LOGO_COLORS.ring} />
      <circle cx={RING.cx} cy={-RING.cy} r={RING.inner} fill={LOGO_COLORS.leaf} />
      <circle cx={RING.cx} cy={-RING.cy} r={RING.pupil} fill={LOGO_COLORS.pupil} />
    </svg>
  );
}
